import React from "react";
import { motion } from "framer-motion";
import { FileCheck2, Landmark, FileText, Award, ShieldCheck } from "lucide-react";

const badges = [
  { icon: Landmark, title: "Ministerio de Ambiente", sub: "PBA · ex-OPDS" },
  { icon: FileCheck2, title: "Manifiestos Electrónicos", sub: "Trazabilidad digital" },
  { icon: FileText, title: "Certificado de", sub: "Disposición Final" },
  { icon: Award, title: "Plantas Habilitadas", sub: "Red de tratamiento" },
  { icon: ShieldCheck, title: "Resoluciones", sub: "Cumplimiento vigente" },
];

export default function Compliance() {
  return (
    <section
      id="cumplimiento"
      data-testid="compliance-section"
      className="bg-concrete relative border-y-2 border-asphalt py-20"
    >
      <div className="max-w-[1500px] mx-auto px-5 md:px-8">
        <div className="grid lg:grid-cols-12 gap-8 items-end mb-12">
          <div className="lg:col-span-6">
            <div className="tag text-forest-600 mb-4 lime-rule">
              Habilitaciones y cumplimiento
            </div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-asphalt leading-[0.92]">
              Operamos bajo
              <br />
              <span className="text-forest-700">estándares oficiales.</span>
            </h2>
          </div>
          <p className="lg:col-span-6 text-forest-600 leading-relaxed max-w-lg">
            Todas nuestras operaciones cumplen con la normativa vigente del
            Ministerio de Ambiente de la Provincia de Buenos Aires. Brindamos
            documentación de respaldo en cada etapa: manifiestos electrónicos,
            certificados de disposición final y reportes de trazabilidad.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 border-2 border-asphalt">
          {badges.map((b, i) => {
            const Icon = b.icon;
            return (
              <motion.div
                key={b.title}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.06 }}
                data-testid={`compliance-badge-${i}`}
                className={`bg-bone p-7 md:p-8 flex flex-col items-start gap-4 hover:bg-forest-900 hover:text-bone group transition-colors ${
                  i < 4 ? "lg:border-r-2" : ""
                } ${i < 2 ? "md:border-r-2" : ""} ${i % 2 === 0 ? "border-r-2 lg:border-r-2" : ""} ${
                  i >= 3 ? "border-t-2 lg:border-t-0" : ""
                } ${i >= 2 ? "border-t-2 md:border-t-0" : ""} border-asphalt`}
              >
                <div className="w-12 h-12 inline-flex items-center justify-center border-2 border-asphalt group-hover:border-lime-400 group-hover:bg-lime-400 group-hover:text-asphalt transition-colors">
                  <Icon className="w-6 h-6" strokeWidth={1.6} />
                </div>
                <div>
                  <div className="font-display text-xl md:text-2xl leading-tight">
                    {b.title}
                  </div>
                  <div className="tag text-forest-600 group-hover:text-lime-400 mt-2 transition-colors">
                    {b.sub}
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
